module.exports = __webpack_public_path__ + "img/c2.a38c8d30.png";